import { Controller, useFormContext } from "react-hook-form";
import type { BoxSelectComponentProps } from "./BoxSelectComponent";
import { BoxSelectComponent } from "./BoxSelectComponent";
import "./styles.scss";

export interface BoxSelectProps extends BoxSelectComponentProps {
  name: string;
}

export const BoxSelect = ({ name, ...passThroughProps }: BoxSelectProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value },
      }: {
        field: {
          onChange: (value: string[]) => void;
          value: string[];
          name: string;
        };
      }) => (
        <BoxSelectComponent
          {...passThroughProps}
          onChange={onChange}
          value={value}
        />
      )}
    />
  );
};
